import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL;

export default function AddGuestPost() {
  const [form, setForm] = useState({ title: '', content: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { getIdToken } = useAuth();
  const navigate = useNavigate();

  function set(field) {
    return (e) => setForm((f) => ({ ...f, [field]: e.target.value }));
  }

  async function handleSubmit(e, published) {
    e.preventDefault();
    setError(''); setSuccess('');
    if (!form.title.trim() || !form.content.trim()) {
      return setError('Title and content are required.');
    }
    setLoading(true);
    try {
      const token = getIdToken();
      await axios.post(
        `${API_URL}/api/articles.json`,
        { ...form, published },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccess(published ? 'Guest post published!' : 'Saved as draft.');
      setTimeout(() => navigate('/dashboard/guest-posts'), 1200);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save guest post.');
    }
    setLoading(false);
  }

  return (
    <div>
      <h2 style={s.pageTitle}>Add Guest Post</h2>
      {error && <div style={s.error}>{error}</div>}
      {success && <div style={s.successMsg}>{success}</div>}

      <div style={s.card}>
        <form>
          <Field label="Title *">
            <input style={s.input} type="text" value={form.title} onChange={set('title')} placeholder="Guest post title..." />
          </Field>
          <Field label="Content *">
            <textarea style={{ ...s.input, resize: 'vertical', lineHeight: 1.7 }} rows={18} value={form.content} onChange={set('content')} placeholder="Write your guest post content here..." />
          </Field>
          <div style={s.actions}>
            <button type="button" disabled={loading} style={s.btnOutline} onClick={(e) => handleSubmit(e, false)}>
              {loading ? 'Saving...' : 'Save as Draft'}
            </button>
            <button type="submit" disabled={loading} style={s.btnPrimary} onClick={(e) => handleSubmit(e, true)}>
              {loading ? 'Publishing...' : 'Publish Now'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div style={{ marginBottom: '1.25rem' }}>
      <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 600, color: '#444', marginBottom: '0.3rem' }}>{label}</label>
      {children}
    </div>
  );
}

const s = {
  pageTitle: { margin: '0 0 1.5rem', fontSize: '1.4rem', fontWeight: 700, color: '#1a1a2e' },
  error: { background: '#fee', border: '1px solid #fcc', padding: '0.75rem 1rem', borderRadius: 6, marginBottom: '1rem', color: '#c00', fontSize: '0.9rem' },
  successMsg: { background: '#f0fdf4', border: '1px solid #bbf7d0', padding: '0.75rem 1rem', borderRadius: 6, marginBottom: '1rem', color: '#15803d', fontSize: '0.9rem' },
  card: { background: '#fff', borderRadius: 10, padding: '2rem', boxShadow: '0 2px 12px rgba(0,0,0,0.07)' },
  input: { width: '100%', padding: '0.65rem 0.9rem', borderRadius: 6, border: '1px solid #ddd', fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box', fontFamily: 'system-ui, sans-serif' },
  actions: { display: 'flex', gap: '1rem', justifyContent: 'flex-end' },
  btnPrimary: { padding: '0.75rem 1.75rem', background: '#1565c0', color: '#fff', border: 'none', borderRadius: 6, fontSize: '0.95rem', fontWeight: 600, cursor: 'pointer' },
  btnOutline: { padding: '0.75rem 1.75rem', background: 'transparent', color: '#555', border: '1px solid #ccc', borderRadius: 6, fontSize: '0.95rem', fontWeight: 600, cursor: 'pointer' },
};
